// ARQUIVO ATUALIZADO
import React from 'react';
import Modal from '../ui/Modal';
import GlassButton from '../ui/Button';
import { CloseIcon, SunIcon, MoonIcon, ComputerDesktopIcon } from '../ui/Icons';
import useData from '../../hooks/useData';

const SettingsModal = ({ isOpen, onClose }) => {
    const { theme, handleThemeChange } = useData();

    const themeOptions = [
        { name: 'light', label: 'Claro', icon: SunIcon },
        { name: 'dark', label: 'Escuro', icon: MoonIcon },
        { name: 'system', label: 'Sistema', icon: ComputerDesktopIcon },
    ];

    if (!isOpen) return null;
    return (
        <Modal isOpen={isOpen} onClose={onClose} maxWidth="max-w-2xl">
            <div className="p-6 border-b border-white/10 flex justify-between items-center">
                <h2 className="text-2xl font-bold text-white">Configurações Gerais</h2>
                <button onClick={onClose} className="text-gray-400 hover:text-white">
                    <CloseIcon size={24} />
                </button>
            </div>
            <div className="p-6 space-y-6 max-h-[70vh] overflow-y-auto">
                
                <div>
                    <h3 className="text-lg font-bold text-white mb-4">Aparência</h3>
                    <div className="bg-white/5 p-4 rounded-lg">
                        <p className="text-sm text-gray-300 mb-3">Tema do aplicativo</p>
                        <div className="flex gap-2 rounded-lg bg-black/20 p-1">
                            {themeOptions.map(option => {
                                const Icon = option.icon;
                                const isActive = theme === option.name;
                                return (
                                    <button
                                        key={option.name}
                                        onClick={() => handleThemeChange(option.name)}
                                        className={`flex-1 flex items-center justify-center gap-2 py-2 text-sm rounded-md transition-colors ${isActive ? 'bg-indigo-500 text-white' : 'hover:bg-white/10 text-gray-300'}`}
                                    >
                                        <Icon size={16} />
                                        <span>{option.label}</span>
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <hr className="border-white/10" />

                <div className="flex items-center justify-between text-white">
                    <span>Notificações Sonoras</span>
                    <input type="checkbox" className="toggle toggle-primary" defaultChecked />
                </div>
                
            </div>
            <div className="p-6 flex justify-end bg-black/20 rounded-b-2xl">
                <GlassButton onClick={onClose} className="bg-indigo-500 hover:bg-indigo-600">
                    Fechar
                </GlassButton>
            </div>
        </Modal>
    );
};

export default SettingsModal;